import { LocaleEnum, ShortLocaleEnum } from 'schema/locale';
import { subscriptionPeriodSchema } from '../../schema/upscribe';

export const pluralizeBase = (
  count: number,
  noun: string,
  local?: LocaleEnum | ShortLocaleEnum,
  suffix = 's'
) => {
  if (local === LocaleEnum.deEU || local === ShortLocaleEnum.de) {
    return noun;
  }
  return `${noun}${count !== 1 ? suffix : ''}`;
};

export const pluralize = (
  count: number,
  noun: string,
  local?: LocaleEnum | ShortLocaleEnum,
  suffix = 's'
) => `${count} ${pluralizeBase(count, noun, local, suffix)}`;

export const pluralizeSubscriptionPeriod = (interval: number, period: string) => {
  const { days, weeks, months } = subscriptionPeriodSchema.enum;
  const periodWithoutSuffix =
    period === days || period === weeks || period === months ? period.slice(0, -1) : period;

  return pluralize(interval, periodWithoutSuffix);
};
